import { Brikk } from 'components/Brikk';
import { IntlPageTitle } from 'components/intl/IntlPageTitle';
import { Grid } from 'components/layout/Grid';
import React, { createContext, useState } from 'react';
import { DateSelectionSection } from 
  'components/brikks/home/LaundryService/components/LaundryBrikkContent/components/DateSelectionSection/index';
import { WhatAndWhenSection } from 
  'components/brikks/home/LaundryService/components/LaundryBrikkContent/components/WhatAndWhenSection/index';
import { BookingsAndRemindersSection } from 
  'components/brikks/home/LaundryService/components/LaundryBrikkContent/components/BookingsAndRemindersSection/index';

export const LaundryBrikkModalContext = createContext();

export const LaundryBrikkContent = ({ laundryResources }) => {
  const [selectedResource, setSelectedResource] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState();

  return (
    <LaundryBrikkModalContext.Provider value={{ selectedDate,
      selectedEndDate,
      setSelectedDate, 
      setSelectedEndDate,
      selectedResource,
      setSelectedResource }}
    >
      <Grid brikkLayout>
        <IntlPageTitle intlTitle="laundryBrikk" />

        <Grid.Column>
          <Brikk.Heading
            main
            heading="laundryBrikk"
          >
            <DateSelectionSection
              laundryResources={laundryResources}
            />
          </Brikk.Heading>
        </Grid.Column>

        <Grid.Column>
          <Brikk.Heading heading="whatAndWhen">
            <WhatAndWhenSection />
          </Brikk.Heading>
        </Grid.Column>

        <Grid.Column>
          <Brikk.Heading heading="bookingsAndReminders">
            <BookingsAndRemindersSection
              laundryResources={laundryResources}
            />
          </Brikk.Heading>
        </Grid.Column>
      </Grid>
    </LaundryBrikkModalContext.Provider>
  );
};
